/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Brief_Stork_LeadInputs */

const fr_bright_brief_stork_lead = /** @type {(inputs: Bright_Brief_Stork_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

/**

* @param {Bright_Brief_Stork_LeadInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bright_brief_stork_lead = /** @type {((inputs?: Bright_Brief_Stork_LeadInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Brief_Stork_LeadInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bright_brief_stork_lead(inputs)
});